import React, { useState } from "react";

const LoanChecklist = ({
  id_R,
  closeLoanChecklistOpen,
  isLoanChecklistOpen,
  openFinalizeLoanApprovalOpen,
  openAmountReviewOpen,
  identityVerified,
  setIdentityVerified,
  kycValid,
  setKycValid,
  guarantorVerified,
  setGuarantorVerified,
  savingsRequirementMet,
  setSavingsRequirementMet,
  noOutstandingDefaults,
  setNoOutstandingDefaults,
  membershipTenureMet,
  setMembershipTenureMet,
  documentsReviewed,
  setDocumentsReviewed,
}) => {
  const handleBackButton = () => {
    closeLoanChecklistOpen();

    openAmountReviewOpen();
  };

  const checklistItems = [
    {
      label: "Have you verified the member’s identity?",
      state: identityVerified,
      setter: setIdentityVerified,
    },
    {
      label: "Are all KYC documents uploaded and valid?",
      state: kycValid,
      setter: setKycValid,
    },
    {
      label:
        "Have you verified guarantor information (SACCO member, sufficient savings etc.)?",
      state: guarantorVerified,
      setter: setGuarantorVerified,
    },
    {
      label:
        "Does this member meet the minimum savings requirement for this loan?",
      state: savingsRequirementMet,
      setter: setSavingsRequirementMet,
    },
    {
      label:
        "Have you confirmed that this member doesn’t have outstanding defaults?",
      state: noOutstandingDefaults,
      setter: setNoOutstandingDefaults,
    },
    {
      label:
        "Does this member meet the minimum SACCO membership tenure requirement?",
      state: membershipTenureMet,
      setter: setMembershipTenureMet,
    },
    {
      label: "All documents reviewed and meet compliance standards",
      state: documentsReviewed,
      setter: setDocumentsReviewed,
    },
  ];

  const handleContinueButton = () => {
    closeLoanChecklistOpen();

    openFinalizeLoanApprovalOpen();
  };

  return (
    <div
      id={id_R}
      className={`${
        isLoanChecklistOpen ? "flex" : "hidden"
      } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
    >
      <div className="relative flex items-center fixed min-h-screen w-[60%] max-w-[100%] h-full md:h-auto">
        <div className="relative justify-end bg-white shadow w-[100%] mx-auto h-[95vh] px-4">
          <div className="justify-end rounded-t flex items-end">
            <button
              onClick={closeLoanChecklistOpen}
              type="button"
              className="bg-transparent rounded-lg text-sm p-2.5 ml-auto inline-flex items-center"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.84 12L5.7 8.9L3.9 12H0.2L3.88 6.3L0.1 0.839999H3.94L6.08 3.92L7.88 0.839999H11.58L7.84 6.46L11.68 12H7.84Z"
                  fill="black"
                />
              </svg>
            </button>
          </div>

          <div className="flex items-center mt-5">
            <p className="text-[#000000] text-[20px] font-[700]">
              Loan Approval Checklist
            </p>
          </div>

          <div className="mt-4">
            <p className="text-[15px] font-[300] text-[#000000]">
              Review and confirm all required checks before approving this loan.
              This checklist ensures due diligence in
              <br />
              verifying the borrower's eligibility, loan completeness, and
              compliance with approval criteria. By completing
              <br />
              this checklist, you acknowledge responsibility for the loan
              approval decision.
            </p>
          </div>

          <div className="w-[99%] h-[50vh] mt-8 mx-auto items-center border-[1px] overflow-y-auto border-[#000000] p-[20px] rounded-[5px]">
            {checklistItems.map((item, index) => (
              <div
                key={index}
                className="flex items-center w-full justify-between mb-4"
              >
                <p>{item.label}</p>
                <div className="flex items-center gap-[5px]">
                  <div
                    className={`px-[10px] py-[2px] cursor-pointer ${
                      item.state === "No" ? "bg-[#DADADA]" : "bg-transparent"
                    }`}
                    onClick={() => item.setter("No")}
                  >
                    No
                  </div>
                  <div
                    className={`px-[10px] py-[2px] cursor-pointer ${
                      item.state === "Yes" ? "bg-[#06B217]" : "bg-transparent"
                    }`}
                    onClick={() => item.setter("Yes")}
                  >
                    Yes
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-end justify-between w-[99%] h-[10vh] mt-5">
            <button
              onClick={handleBackButton}
              type="button"
              className="text-[#005C53] font-[500] rounded-[5px] text-[16px] px-16 py-2 bg-[#8ED6A8]"
            >
              Back
            </button>
            <button
              onClick={handleContinueButton}
              type="button"
              className="text-white bg-[#005C53] hover:bg-[#005C53] focus:outline-none block rounded-[5px] text-[16px] font-[500] px-16 py-2.5"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoanChecklist;
